// models/Tutorials.js
export class Tutorials {
  constructor(data = {}) {
    // Initialize all tutorial fields with proper boolean values
    this.tutorial_1 = data.tutorial_1 === true || data.tutorial_1 === 'true';
    this.tutorial_2 = data.tutorial_2 === true || data.tutorial_2 === 'true';
    this.tutorial_3 = data.tutorial_3 === true || data.tutorial_3 === 'true';
    this.tutorial_4 = data.tutorial_4 === true || data.tutorial_4 === 'true';
    this.tutorial_5 = data.tutorial_5 === true || data.tutorial_5 === 'true';
    this.tutorial_6 = data.tutorial_6 === true || data.tutorial_6 === 'true';
    this.tutorial_7 = data.tutorial_7 === true || data.tutorial_7 === 'true';
    this.tutorial_8 = data.tutorial_8 === true || data.tutorial_8 === 'true';
    this.tutorial_9 = data.tutorial_9 === true || data.tutorial_9 === 'true';
    this.tutorial_10 = data.tutorial_10 === true || data.tutorial_10 === 'true';
  }

  // Check if a specific tutorial is completed
  isCompleted(tutorialNumber) {
    const key = `tutorial_${tutorialNumber}`;
    return this[key] === true;
  }

  // Mark a tutorial as completed
  complete(tutorialNumber) {
    const key = `tutorial_${tutorialNumber}`;
    this[key] = true;
  }

  // Get all tutorials as an object
  toJSON() {
    return {
      tutorial_1: this.tutorial_1,
      tutorial_2: this.tutorial_2,
      tutorial_3: this.tutorial_3,
      tutorial_4: this.tutorial_4,
      tutorial_5: this.tutorial_5,
      tutorial_6: this.tutorial_6,
      tutorial_7: this.tutorial_7,
      tutorial_8: this.tutorial_8,
      tutorial_9: this.tutorial_9,
      tutorial_10: this.tutorial_10
    };
  }

  // Create from JSON
  static fromJSON(json) {
    return new Tutorials(json);
  }
}